import MUIDataTable from "mui-datatables";
import { translate } from "../../../../config/localisation";

// Обёртка над MUIDataTable: подставляет переведённые подписи по всему набору.
// Пользовательские текстовые подписи тоже прогоняются через translate(),
// поэтому кастомные значения ("No records" и т.п.) переводятся автоматически;
// строки, которых нет в словаре, остаются как есть.
const T = (val, def) => translate(typeof val === "string" ? val : def);

const DataTable = ({ options = {}, ...rest }) => {
  const tl = options.textLabels || {};
  const b = tl.body || {};
  const p = tl.pagination || {};
  const tb = tl.toolbar || {};
  const fl = tl.filter || {};
  const vc = tl.viewColumns || {};
  const sr = tl.selectedRows || {};
  const merged = {
    ...options,
    textLabels: {
      ...tl,
      body: {
        noMatch: T(b.noMatch, "No records"),
        toolTip: T(b.toolTip, "Sort"),
        columnHeaderTooltip:
          b.columnHeaderTooltip ||
          ((column) => translate("Sort") + ": " + column.label),
      },
      pagination: {
        next: T(p.next, "Next Page"),
        previous: T(p.previous, "Previous Page"),
        rowsPerPage: T(p.rowsPerPage, "Rows per page:"),
        displayRows: T(p.displayRows, "of"),
        jumpToPage: T(p.jumpToPage, "Jump to page:"),
      },
      toolbar: {
        search: T(tb.search, "Search"),
        downloadCsv: T(tb.downloadCsv, "Download CSV"),
        print: T(tb.print, "Print"),
        viewColumns: T(tb.viewColumns, "View Columns"),
        filterTable: T(tb.filterTable, "Filter Table"),
      },
      filter: {
        all: T(fl.all, "All"),
        title: T(fl.title, "FILTERS"),
        reset: T(fl.reset, "RESET"),
      },
      viewColumns: {
        title: T(vc.title, "Show Columns"),
        titleAria: T(vc.titleAria, "View Columns"),
      },
      selectedRows: {
        text: T(sr.text, "row(s) selected"),
        delete: T(sr.delete, "Delete"),
        deleteAria: T(sr.deleteAria, "Delete Selected Rows"),
      },
    },
  };
  return <MUIDataTable {...rest} options={merged} />;
};

export default DataTable;
